<script setup lang="ts">

</script>

<template>
    <nav class="ods-navigation">
        <slot>

        </slot>
    </nav>
</template>

<style lang="scss" src="./odsNavigation.scss">
</style>